import * as types from '../constants'

const defaultState = {
  users: [],
  user: {},
  getUsersPending: false,
  createPending: false,
  updatePending: false,
  updatePending: false,
  error: null,
  user_tags: [],
  user_tags_request_error: null,
}

export default (state = defaultState, action) => {

  var newState = {...state}

  switch (action.type){
    case types.GET_USERS_REQUEST:
      newState.getUsersPending = true;
      return newState;
    case types.GET_USERS_SUCCESS:
      newState.users = action.body;
      newState.getUsersPending = false;
      return newState;
    case types.GET_USERS_FAILURE:
      newState.getUsersPending = false;
      return newState;
    case types.CREATE_USER_REQUEST:
      newState.createPending = true;
      newState.error = null;
      return newState;
    case types.CREATE_USER_SUCCESS:
      newState.user = action.body;
      newState.createPending = false;
      return newState;
    case types.CREATE_USER_FAILURE:
      newState.createPending = false;
      newState.error = action.exception;
      return newState;
    case types.UPDATE_USER_REQUEST:
      newState.updatePending = true;
      newState.error = null;
      return newState;
    case types.UPDATE_USER_SUCCESS:
      newState.user = action.body;
      newState.updatePending = false;
      return newState;
    case types.UPDATE_USER_FAILURE:
      newState.updatePending = false;
      newState.error = action.exception;
      return newState;
    case types.DELETE_USER_REQUEST:
      newState.deletePending = true;
      return newState;
    case types.DELETE_USER_SUCCESS:
      newState.user = action.body;
      newState.deletePending = false;
      return newState;
    case types.DELETE_USER_FAILURE:
      newState.deletePending = false;
      return newState;
    case types.CLEAR_USER_ERROR:
      newState.error = null;
      return newState;
    case types.GET_USER_TAGS_REQUEST:
      return newState
    case types.GET_USER_TAGS_SUCCESS:
      newState.user_tags = action.body
      return newState
    case types.GET_USER_TAGS_FAILURE:
      return newState

    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js